export default __webpack_public_path__ + "static/media/icon-trezor.c1fa164a.svg";